module.exports = __webpack_public_path__ + "static/media/kia-pin.2f9b8084.svg";